import React,{useEffect} from 'react'
import './CurrentOpenings.css'
import Apply_Btn from '../../Common-Component/Common_Btn/Apply_Btn/Apply_Btn'
import CommonHeadingBeforeAfterLine from '../../Common-Component/CommonHeadingBeforeAfterLine/CommonHeadingBeforeAfterLine'
import { useNavigate } from 'react-router-dom'
import { getCareer } from '../../../features/career/careerSlice'
import { useDispatch, useSelector } from "react-redux";

const CurrentOpenings = () => {

    const career = useSelector((state) => state.career.addCareer);
    const dispatch = useDispatch();
   
  
    useEffect(() => {dispatch(getCareer());
        },[dispatch]);


    // const jobs = ["Consultant", "Store Manager", "Telesales Executive", "Graphic Designer",
    //     "Sr. Manager Finance & Accounts", "Key Relationship Manager", "Business Development Executive",
    //     "Business Development Executive"
    // ]

    const navigate = useNavigate();

    return (
        <section className='CurrentOpenings'>

            {/* <div class="section_heading_div">
                <p class="heading_text">
                    Current Openings
                </p>
            </div> */}

            <CommonHeadingBeforeAfterLine headingText="Current Openings" />


            <div className='main_job_holder'>

                <div className='row'>
                {career && career.length > 0 ? (
                        career.map((job, index) => (
                            <div key={index} className='col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12'>
                                <div
                                    className='job_card'
                                    onClick={() => navigate(`/job-application-form/${job.id}`)}
                                >
                                    <div className='title_holder'>
                                        <p className='title'>Job Role:</p>
                                    </div>

                                    <div className='job_title'>
                                        <p className='text'>{job.job_role}</p>
                                    </div>

                                    <div className='apply_btn_holder'>
                                        <Apply_Btn 
                                            btnText="Apply"
                                            onClick={() => navigate("/job-application-form")}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No job openings available</p>
                    )}
                </div>
            </div>
        </section>
    )
}

export default CurrentOpenings
